// validationSchema.ts
import * as yup from "yup";

export const tokensSchema = yup.object().shape({
  id_token: yup.number().nullable(),
  empresa: yup.string().required("A empresa é obrigatório"),
  licenca: yup.string().required("O código da licença é obrigatório"),
  app_token: yup.string().required("O App Token é obrigatório"),
  access_token: yup.string().required("O Access Token é obrigatório"),
});
